import React from 'react'
import styled from 'styled-components'
import { Modal } from 'antd'
import duplicateIcon from 'src/assets/images/common/duplicate_icon.png'
import closeCircle from 'src/assets/icons/close-circle-svgrepo-com.svg'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { PATH as PATH_AUTH } from 'src/pages/auth'
import iconRight from 'src/assets/icons/right_white.svg'
import { DuplicateType } from 'src/interfaces/duplicateAccount'

type Props = {
  open: boolean
  onClose: () => void
  type: DuplicateType
  value: string
  name?: string
  contactEmail?: string
}

const DUPLICATE_LABEL: Record<DuplicateType, string> = {
  email: 'メールアドレス',
  phone: '電話番号',
}

// [SCOPE] No.154 — client chose 案B (No_154_Client_QA_JP.md Q1): this modal only
// shows the duplicate notice, the 3-choice UI now lives on a dedicated page.
const DuplicateAccountModal: React.FC<Props> = ({
  open,
  onClose,
  type,
  value,
  name,
  contactEmail,
}) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const label = DUPLICATE_LABEL[type]

  const handleProceedClick = () => {
    navigate(
      `${PATH_AUTH.DUPLICATE_ACCOUNT_OPTIONS}?${searchParams.toString()}`,
      { state: { type, value, name, contactEmail } },
    )
  }

  return (
    <StyledModal open={open} footer={null} closable={false} centered>
      <div className="content">
        <img src={duplicateIcon} alt="" className="icon" />
        <h3 className="text">
          すでにアカウント登録がございます。
          <br />
          同じ{label}で再登録することはできません。
        </h3>
        <h3 className="text">
          お手続き方法をご案内いたしますので、
          <br />
          下のボタンよりお進みください。
        </h3>

        <div className="buttons">
          <button className="btn gold" onClick={handleProceedClick}>
            <span>次へ進む</span>
            <img src={iconRight} alt="iconRight" className="arrow" />
          </button>
        </div>

        <button className="close" onClick={onClose}>
          <img src={closeCircle} alt="close" />
        </button>
      </div>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    text-align: center;
    padding: 20px 20px 30px;
    position: relative;
    border: 2px solid #333;
    border-radius: 20px;
    max-width: 420px;
    margin: auto;
  }

  .content {
    .icon {
      width: 200px;
      margin-bottom: 15px;
    }

    .text {
      font-size: 14px;
      margin-bottom: 10px;
      font-weight: 700;
    }

    .buttons {
      margin-top: 15px;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .btn {
        padding: 10px;
        border-radius: 50px;
        border: none;
        font-size: 20px;
        cursor: pointer;
        font-weight: 700;
        position: relative;

        &.gray {
          background-color: #666;
          color: white;
        }

        .arrow {
          width: 18px;
          height: 18px;
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
        }

        &.gold {
          background-color: #c5b478;
          color: white;
        }
      }
    }

    .close {
      position: absolute;
      top: 10px;
      right: 15px;
      font-size: 22px;
      background: none;
      border: none;
      cursor: pointer;
    }
  }
`

export default DuplicateAccountModal
